import { cn } from '@helpers/cn';
import type { ReactNode } from 'react';

interface MfaPillProps {
  /** Green for a method that is on, grey for one that is off, yellow for advice. */
  tone: 'on' | 'off' | 'recommended';
  children: ReactNode;
  className?: string;
}

const tones = {
  on: 'eye:bg-green-25 eye:text-green-100',
  off: 'eye:bg-grey-10 eye:text-grey-180',
  recommended: 'eye:bg-yellow-100 eye:text-black',
};

/** The small pill next to a second-factor method ("On", "Off", "Recommended"). */
function MfaPill({ tone, children, className }: MfaPillProps) {
  return (
    <span
      className={cn(
        'eye:inline-flex eye:h-24 eye:shrink-0 eye:items-center eye:rounded-full eye:px-[10px] eye:text-14 eye:leading-none eye:font-medium eye:whitespace-nowrap',
        tones[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}

export default MfaPill;
